// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.edit-line{width:500px}.edit-line .modal__header{margin-bottom:20px}.edit-line .modal__controls{margin:20px -16px -50px}.edit-line .form-input{padding:10px 0}`, "",{"version":3,"sources":["webpack://./src/modals/EditLine/style.scss"],"names":[],"mappings":"AACA,WACE,WAAA,CAEA,0BACE,kBAAA,CAGF,4BACE,uBAAA,CAGF,uBACE,cAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
